import { Component } from "@angular/core";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { FuncionamientosDTO } from "src/app/models/funcionaminetos.dto";

@Component({
  selector: "app-form-funcionamiento",
  templateUrl: "./form.component.html",
})
export class FuncionamientoForm extends CrudForm<FuncionamientosDTO> {
  public fromInit(row: FuncionamientosDTO) {
    this.form.controls["IdFuncionamiento"].setValue(row?.IdFuncionamiento);
    this.form.controls["Descripcion"].patchValue(row?.Descripcion);
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdFuncionamiento: [""],
      Descripcion: [""],
    });
  }
}
